<script setup lang="ts">
import {formatMln, formatPercentage, KLEUR_BALK, StatusKleur, TOTAAL_LABEL, UitgavenOverzicht, UitgavenRij} from 'common';

const KLEUR_REALISATIE: string = '#185FA5';
const KLEUR_PROGNOSE: string   = '#85B7EB';

defineProps<{
    uitgaven: UitgavenOverzicht;
    inclPrognose: boolean;
}>();

// segment widths as a share of the available budget, capped at the full bar
function breedte(deel: number, rij: UitgavenRij): number {
    return rij.beschikbaar <= 0 ? 0 : Math.min(100, Math.max(0, deel / rij.beschikbaar * 100));
}

function stip(rij: UitgavenRij): string {
    return rij.kleur === StatusKleur.grijs ? '' : KLEUR_BALK[rij.kleur];
}
</script>

<template>
    <div class="flex flex-col gap-3">
        <div class="flex flex-col gap-2">
            <div v-for="rij in uitgaven.rijen" :key="rij.kostenpost" class="flex flex-row items-center gap-3 text-sm" :class="rij.kostenpost === TOTAAL_LABEL ? 'font-semibold' : ''">
                <div class="w-56 flex items-center gap-2">
                    <span v-if="stip(rij)" class="inline-block w-2.5 h-2.5 rounded-full" :style="{backgroundColor: stip(rij)}"/>
                    {{ rij.kostenpost }}
                </div>
                <div class="flex-1 h-5 rounded border border-gray-300 bg-gray-50 flex overflow-hidden">
                    <div class="h-5 text-white text-xs px-1 whitespace-nowrap overflow-hidden" :style="{width: `${breedte(rij.gerealiseerd, rij)}%`, backgroundColor: KLEUR_REALISATIE}" :title="`gerealiseerd ${formatMln(rij.gerealiseerd)}`"/>
                    <div v-if="inclPrognose" class="h-5 text-xs px-1 whitespace-nowrap overflow-hidden" :style="{width: `${breedte(rij.prognose, rij)}%`, backgroundColor: KLEUR_PROGNOSE}" :title="`prognose ${formatMln(rij.prognose)}`"/>
                </div>
                <div class="w-32 text-right">{{ formatMln(rij.gerealiseerd + (inclPrognose ? rij.prognose : 0)) }}</div>
                <div class="w-32 text-right text-gray-500">van {{ formatMln(rij.beschikbaar) }}</div>
                <div class="w-16 text-right">{{ formatPercentage(rij.uitputting) }}</div>
            </div>
        </div>
        <div class="text-xs text-gray-500">Cumulatief sinds 2023 t.o.v. beschikbaar IZA-budget. Percentage = uitputting incl. prognose; oranje vanaf 90%, rood boven 100%.</div>
    </div>
</template>
